import { Stack, styled } from '@mui/material';
import { shouldForwardPropExclude } from '@synergy/utils';

export const StyledSumTableRow = styled(Stack, {
    shouldForwardProp: shouldForwardPropExclude('isModal'),
})<{ isModal?: boolean }>(({ theme, isModal }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    paddingBlock: theme.spacing(1),
    ...(isModal && {
        paddingInline: theme.spacing(2),
        marginInline: theme.spacing(-2),
        backgroundColor: theme.palette.grey[200],
    }),
}));
